<template>
  <div class="status" :style="styles">
    <p v-if="isSuccessful" class="success-txt">
      {{ isSuccessful }}
    </p>
    <p v-else-if="isPending" class="pending-txt">
      {{ isPending }}
    </p>

    <p v-else-if="isFailed" class="failed-txt">
      {{ isFailed }}
    </p>

    <p v-else-if="isCancelled" class="failed-txt">
      {{ isCancelled }}
    </p>

    <p v-else-if="isProcessing" class="processing-txt">
      {{ isProcessing }}
    </p>

    <p v-else class="unknown-txt">
      {{ unknownStatus ? unknownStatus : "N/A" }}
    </p>
  </div>
</template>
<script>
import startCase from "lodash/startCase";

export default {
  name: "StatusIndicatorWithWords",
  props: {
    type: String,
    styles: String,
  },

  computed: {
    isSuccessful() {
      const value = ['successful', 'settled', 'active', "up"].includes(
          (this.type && this.type.toString().toLowerCase())
      );
      return value ? startCase(this.type.toString().toLowerCase()) : false;
    },

    isFailed() {
      const value = [
        "inactive",
        "failed",
        "stop",
        "unsettled",
        "down",
        "declined",
      ].includes(this.type && this.type.toString().toLowerCase());
      return value ? startCase(this.type.toString().toLowerCase()) : false;
    },

    isPending() {
      const value = [
        "pending",
        "pending_customer_approval",
        "pending_kyc_review",
      ].includes(this.type && this.type.toString().toLowerCase());
      return value
        ? startCase(this.type.toString().toLowerCase().replace("_", " "))
        : false;
    },

    isProcessing() {
      const value = ['processing', "unstable"].includes(
          (this.type && this.type.toString().toLowerCase())
      );
      return value
        ? startCase(this.type.toString().toLowerCase().replace("_", " "))
        : false;
    },

    isCancelled() {
      const value = ["cancelled", "stopped"].includes(
        this.type && this.type.toString().toLowerCase()
      );
      return value ? startCase(this.type.toString().toLowerCase()) : false;
    },

    unknownStatus() {
      return this.type
        ? startCase(this.type.toString().toLowerCase().replace("_", " "))
        : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.status {
  span {
    color: transparent;
  }

  .success-txt {
    color: #15ce9a;
  }

  .pending-txt {
    color: #b59b01;
  }

  .processing-txt {
    color: #17a0fb;
  }

  .failed-txt {
    color: #c61211;
  }

  .unknown-txt {
    color: #030d18;
  }
}
</style>
